import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { accountSend } from "@/lib/api";
import { useAuth, getIntendedRole } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/entrar", { replace: true }); return; }
    const role = getIntendedRole();
    (async () => {
      try {
        const r = await accountSend("/account/google", "POST", { session_id: sid, role });
        setUser(r.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(r.user.role === "fornecedor" ? "/painel-fornecedor" : "/minha-conta", { replace: true });
      } catch (e) {
        toast.error("Não foi possível entrar", { description: e.message });
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/entrar", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-maternnia-porcelana/40">
      <div className="text-center">
        <Loader2 className="animate-spin text-maternnia-eucalipto mx-auto" size={30} />
        <p className="mt-4 text-sm text-maternnia-taupe font-light">Entrando com segurança...</p>
      </div>
    </main>
  );
};

export default AuthCallback;
